export default `
  query getWishlistsByCustomerSourceId ($customerId: String!, $first: Int, $nextToken: String) {
    getWishlistsByCustomerSourceId (customerId: $customerId, first: $first, nextToken: $nextToken) {
      items {
        id,
        customerSourceId,
        title
        
        items {
          variantId
          handle
        }
      }
      nextToken
    }
  }
`
